import { Component } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-splash',
  template: `
    <div class="splash">
      <div class="box">
        <div class="ring">
          <!-- SVG do anel “incompleto” girando -->
          <svg viewBox="0 0 120 120" class="ring-svg" aria-hidden="true">
            <!-- trilha clarinha, opcional -->
            <circle cx="60" cy="60" r="46" class="track"/>
            <!-- arco animado -->
            <circle cx="60" cy="60" r="46" class="arc"/>
          </svg>

          <!-- seu logo no centro -->
          <img class="logo" src="/assets/images/brand/logo.png" alt="SmartLab Facens">
        </div>
      </div>
    </div>
  `,
  styles: [`
    .splash {
      position: fixed;
      inset: 0;
      background: #fff;              /* fundo inteiro branco */
      display: grid;
      place-items: center;
      z-index: 9999;                 /* acima de tudo */
    }
    .box { display: grid; place-items: center; }

    .ring {
      position: relative;
      width: 160px;
      height: 160px;
    }

    .logo {
      position: absolute;
      inset: 0;
      margin: auto;
      width: 84px;
      height: 84px;
      object-fit: contain;
      filter: drop-shadow(0 1px 2px rgba(0,0,0,.08));
    }

    .ring-svg {
      width: 160px;
      height: 160px;
      transform-origin: 50% 50%;
      animation: spin 1.2s linear infinite;
    }

    .track {
      fill: none;
      stroke: #eaeaea;
      stroke-width: 10;
    }

    .arc {
      fill: none;
      stroke: #10b6a6;
      stroke-width: 10;
      stroke-linecap: round;
      /* arco ~65% do círculo */
      stroke-dasharray: 190 500;
      stroke-dashoffset: 0;
    }

    @keyframes spin {
      to { transform: rotate(360deg); }
    }
  `]
})
export class SplashComponent {}
